import React from 'react';

const defaultContext = Object.freeze({});
export const ScrollContext = React.createContext(defaultContext);
